<template>
  <div :class="$route.name === 'top' ? 'home-footer' : 'container-footer'">
    <div class="wrap">
      <div class="footer-title">
        {{$t('T_DISCLAIMER_TITLE')}}
      </div>
      <div class="footer-item" :class="{'footer-item-out-of-spec': isOutOfSpec}">
        <ul>
          <li v-for="(item, index) in listData" :key='index' :class="{'out_of_spec': isOutOfSpec}">{{$t(item.id)}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Footer',
  data () {
    return {
      array: [
        {id: 'T_DISCLAIMER_1'},
        {id: 'T_DISCLAIMER_2'},
        {id: 'T_DISCLAIMER_3'},
        {id: 'T_DISCLAIMER_4'}
      ],
      arrayOutOfSpec: [{id: 'T_OUT_OF_SPEC_MODE_REPORT'}]
    }
  },
  computed: {
    ...mapState(['isOutOfSpec']),
    listData () {
      return this.isOutOfSpec ? this.arrayOutOfSpec : this.array
    }
  }
}

</script>

<style scoped>
.container-footer {
  padding: 20px 0px;
  background: #f3f3f3;
}

.footer-title {
  font-size: 14px;
  font-weight: bold;
  padding: 0px 0px 10px;
}

.footer-item {
  font-size: 14px;
  color: #666666;
  line-height: 16px;
  margin-left: 15px;

}
.footer-item-out-of-spec{
  margin-left: 0;
}
.pdf_footer .footer-item-out-of-spec{
  padding-right: 70px;
}
.footer-item ul li {
  list-style: disc;
}
.out_of_spec {
  list-style: none!important;
  color:red;
}

.home-footer {
  padding: 20px 0px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue